import React, { useEffect, useState } from 'react';
import useBackendApi from '../../../hooks/useBackendApi';
import GradientCircularProgressContainer from '../../../components/common/GradientCircularProgressContainer';
import { useThemeContext } from '../../../contexts/ThemeContext.js';

const QboConnect: React.FC = () => {
  const { apiFetchRequest } = useBackendApi();
  const [error, setError] = useState<string | null>(null);
  const { isMembershipDataReady } = useThemeContext();

  useEffect(() => {
    const connectQbo = async () => {
      try {
        if (!isMembershipDataReady) {
          return;
        }

        const urlParams = new URLSearchParams(window.location.search);
        const slackId = urlParams.get('slack_id');

        if (!slackId) {
          throw new Error('Unable to identify user session.');
        }

        const response = await apiFetchRequest({
          endpoint: '/api/angie/auth/quickbooks/connect',
          method: 'POST',
          body: { user_id: slackId },
        });

        if (response.isError) {
          throw new Error(response.body?.detail || 'Failed to initiate connection');
        }

        if (response.body?.url) {
          // window.location.href = response.body.url;
          setTimeout(() => {
            window.location.assign(response.body.url);
          }, 1000);
        } else {
          setError('Invalid URL returned from server.');
        }
      } catch (err: any) {
        if (err.name === 'AbortError' || err.message.includes('Load failed')) {
          return;
        }
        setError(err.message || 'Failed to initiate connection to QuickBooks');
      }
    };

    connectQbo();
  }, [apiFetchRequest, isMembershipDataReady]);

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen">
        <p className="text-red-600 mb-4">{error}</p>
        <button onClick={() => window.location.reload()} className="px-4 py-2 bg-blue-500 text-white rounded">
          Try Again
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <GradientCircularProgressContainer loadingMessage="Connecting to QuickBooks..." />
    </div>
  );
};

export default QboConnect;
